// Subdomain detection for white-label org branding.
// e.g. stl-hoops.recruitlookevents.com -> "stl-hoops"
// apex (recruitlookevents.com), www, localhost and *.lovable.app -> null

const ROOT_DOMAINS = ['recruitlookevents.com', 'recruitlook.com'];
const IGNORED_LABELS = ['www', 'app', 'staging', 'preview'];

export function getSubdomain(hostname?: string): string | null {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!host) return null;

  // Local dev / Lovable preview never carry org subdomains.
  if (host === 'localhost' || host.endsWith('.localhost') || host.endsWith('.lovable.app') || host.endsWith('.lovableproject.com')) {
    return null;
  }

  // IP addresses have no subdomain.
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return null;

  const root = ROOT_DOMAINS.find((d) => host === d || host.endsWith(`.${d}`));
  if (!root) {
    // Unknown custom domain — derive label only if there's clearly a subdomain.
    const parts = host.split('.');
    if (parts.length < 3) return null;
    const label = parts[0];
    return IGNORED_LABELS.includes(label) ? null : label;
  }

  if (host === root) return null; // apex

  const prefix = host.slice(0, host.length - root.length - 1); // strip ".root"
  if (!prefix) return null;
  const label = prefix.split('.')[0];
  if (!label || IGNORED_LABELS.includes(label)) return null;
  return label;
}

export function hasSubdomain(hostname?: string): boolean {
  return getSubdomain(hostname) !== null;
}
